import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { CheckoutFeeType } from './checkout.fee-type.enum';

export const CheckoutFeeSchema = z
    .object({
        amount: z.number(),
        type: z.string(),
    })
    .strict();

export class CheckoutFee extends FromSchema(CheckoutFeeSchema) {
    amount: number;
    type: CheckoutFeeType;
}
